import React from 'react';
import { ThemeMode } from '../../themes';

interface ActionBarProps extends React.HTMLAttributes<HTMLDivElement> {
  variant: ThemeMode;
  compact?: boolean;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  variant,
  compact = false,
  className,
  children,
  ...rest
}) => {
  const classes = [
    'action-bar',
    `action-bar--${variant}`,
    compact ? 'action-bar--compact' : null,
    className || null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};
